// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
// rem 适配：配合 postcss-pxtorem 使用（会动态设置 html font-size）
//import "lib-flexible/flexible";
import { setupRem } from '@/utils/rem'
import App from "./App";
import router from "./router";
import store from "./store";

import "@/assets/fonts/iconfont/iconfont.css";
import "@/assets/styles/index.scss"; // global css
import "@/assets/styles/resetvatui.scss";

// 引入echarts
import echarts from "@/utils/echarts";

// 挂载到vue实例中
Vue.prototype.$echarts = echarts;
//字体包
import "@/assets/fonts/font.css";
Vue.config.productionTip = false;
import "@/utils/vant";
//--------vue-video-player
import VideoPlayer from "vue-video-player";
window.videojs = VideoPlayer.videojs;
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
require("video.js/dist/lang/zh-CN.js");
setupRem();
Vue.use(VideoPlayer);
//----------分割线
import checkView from "vue-check-view";
Vue.use(checkView);
import Vue2TouchEvents from "vue2-touch-events";
Vue.use(Vue2TouchEvents);
// 导入moment.ja
import moment from "moment";
Vue.prototype.$moment = moment;
// 定位中国使用中文
moment.locale("zh-cn");
// import VConsole from "vconsole/dist/vconsole.min.js";
// let vConsole = new VConsole();
/* eslint-disable no-new */
// router.beforeEach((to, from, next) => {
//   /* 路由发生变化修改页面title */
//   if (to.meta.title) {
//     document.title = to.meta.title;
//   }
//   next();
// });
window.addEventListener(
  "popstate",
  function() {
    router.isBack = true;
  },
  false
);
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js